import { getInstance } from 'StateManager';
import { VIEWABILITY } from 'StateEvents';
import Updater from './Updater';

export default class ViewabilityUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(VIEWABILITY);
  }

  updateState(newState, event) {
    switch(event.name) {
      case VIEWABILITY.INITIALIZED:
        newState.viewability.initialized = event.args;
        break;
      case VIEWABILITY.STARTED:
        newState.viewability.started = true;
        break;
      case VIEWABILITY.UNSUPPORTED:
        newState.viewability.unmeasureable = true;
        break;
      case VIEWABILITY.SNAPSHOT:
        newState.viewability.snapshot = event.args;
        break;
      case VIEWABILITY.ACHIEVED:
        newState.viewability.achieved = event.args;
        break;
      case VIEWABILITY.VIEWABLE:
        newState.viewability.viewable = event.args;
        break;
    }

    return newState;
  }
}

getInstance().registerUpdater(new ViewabilityUpdater());


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/ViewabilityUpdater.js